import React from 'react';
import ReactDOM from 'react-dom';

class VideoDOM_without_blob extends React.Component{

	constructor(props){
		super(props);
		
		this.state = {
			src : "",
			innerPlay : false
		}
	}


	isWaiting(){
		if(typeof this.props.isWaiting != "undefined"){
			this.props.isWaiting();
		}
	}
	
	prepareVideo(){
		this.setState({
			src : this.props.src
		},function(){

			//console.log("load", this.video.load());
			this.loadedmetadata = ()=>{
				
				this.isWaitingAction = ()=>this.isWaiting();
				this.video.addEventListener('waiting',this.isWaitingAction,false);

				this.timeupdate = () => this.props.timeupdate(this.video);
				this.video.addEventListener('timeupdate',this.timeupdate,false);

				this.ended = () =>this.props.ended();
				this.video.addEventListener('ended',this.ended,false);
				
				if(!this.state.innerPlay && this.props.isPlaying){
					this.props.play();
				}
			}

			this.video.addEventListener('loadedmetadata',this.loadedmetadata,false);

		});
	}
	componentDidMount(){
		this.prepareVideo();
	}

	componentWillUnmount(){
		this.video.removeEventListener('loadedmetadata',this.loadedmetadata);
		this.video.removeEventListener('waiting',this.isWaitingAction);
		this.video.removeEventListener('ended',this.ended);
		this.video.removeEventListener('timeupdate',this.timeupdate);
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.isPlaying && !this.state.innerPlay){
			this.setState({
				innerPlay : true
			},function(){
				//change state
				this.props.play();
				//play video
				this.playVideo();
			});
		}else if(!nextProps.isPlaying && this.state.innerPlay){
			this.setState({
				innerPlay : false
			},function(){
				//change state
				this.props.pause();
				//pause video
				this.pauseVideo();
			})
		}
	}

	getDuration(){
		return this.video.duration;
	}

	playVideo(){
		//console.log('play video');
		var videoPromise = this.video.play();
		return videoPromise;
	}

	pauseVideo(){
		//console.log('pause video');
		this.video.pause();
	}
	getCurrentTime(){
		return this.video.currentTime;
	}

	render(){
		return(<div className={ "videoDOM "}>
			<video autoPlay={this.props.autoplay} className="" preload="auto" poster={this.props.poster} playsInline ref={(video)=>{this.video = video;}}>
					<source ref={(src)=>{this.source = src;}} src={this.state.src} type="video/mp4" />
				</video>
		</div>);
	}
}

export default VideoDOM_without_blob;


// WEBPACK FOOTER //
// ./src/scripts/videoDOM_without_blob.js